(function () {
  'use strict';

  var THRESHOLD_FALLBACK_CENTS = 10000;
  var GIFT_PROPERTY = '_free_gift';
  var inflight = false;

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function findGiftLine(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.properties && item.properties[GIFT_PROPERTY]) {
        return { item: item, lineIndex: i + 1, variantId: item.variant_id };
      }
    }
    return null;
  }

  function getThreshold() {
    var el = document.querySelector('[data-free-gift-block]');
    if (el && el.dataset.threshold) {
      var n = parseInt(el.dataset.threshold, 10);
      if (!isNaN(n) && n > 0) return n;
    }
    return THRESHOLD_FALLBACK_CENTS;
  }

  function refreshDrawer() {
    var drawer = document.getElementById('cart');
    if (!drawer) return Promise.resolve();
    return fetch('/?section_id=side-cart', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        drawer.innerHTML = html;
      })
      .catch(function () { /* swallow */ });
  }

  function refreshCartUI() {
    var onCartPage = /^\/cart(\/|$)/.test(window.location.pathname);
    if (onCartPage) {
      window.location.reload();
      return Promise.resolve();
    }
    return refreshDrawer();
  }

  function addGift(variantId) {
    if (inflight) return Promise.resolve();
    inflight = true;
    var properties = {};
    properties[GIFT_PROPERTY] = 'true';
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1, properties: properties }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCartUI(); })
      .catch(function (e) { console && console.warn && console.warn('[free-gift] add failed', e); })
      .finally(function () { inflight = false; });
  }

  function removeGiftByLine(lineIndex) {
    if (inflight) return Promise.resolve();
    inflight = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .catch(function (e) { console && console.warn && console.warn('[free-gift] remove failed', e); })
      .finally(function () { inflight = false; });
  }

  function autoRemoveIfIneligible() {
    return getCart().then(function (cart) {
      var threshold = getThreshold();
      var gift = findGiftLine(cart);
      if (gift && cart.items_subtotal_price < threshold) {
        return removeGiftByLine(gift.lineIndex).then(refreshCartUI);
      }
    });
  }

  function setPreview(dropdown, imgUrl, title) {
    var picker = dropdown.closest('.free-gift-picker');
    if (!picker) return;
    var wrap = picker.querySelector('[data-free-gift-preview-wrap]');
    if (!wrap) return;
    var img = wrap.querySelector('[data-free-gift-preview-img]');
    var placeholder = wrap.querySelector('[data-free-gift-preview-placeholder]');

    if (imgUrl) {
      if (img) {
        img.src = imgUrl;
        img.alt = title || '';
      } else {
        if (placeholder) placeholder.remove();
        var newImg = document.createElement('img');
        newImg.setAttribute('data-free-gift-preview-img', '');
        newImg.src = imgUrl;
        newImg.alt = title || '';
        newImg.width = 120;
        newImg.height = 120;
        wrap.insertBefore(newImg, wrap.firstChild);
      }
    } else if (img) {
      img.remove();
      if (!wrap.querySelector('[data-free-gift-preview-placeholder]')) {
        var ph = document.createElement('span');
        ph.setAttribute('data-free-gift-preview-placeholder', '');
        ph.className = 'free-gift-selector__placeholder';
        ph.setAttribute('aria-hidden', 'true');
        wrap.insertBefore(ph, wrap.firstChild);
      }
    }
  }

  function openDropdown(dropdown) {
    var trigger = dropdown.querySelector('[data-fg-dropdown-trigger]');
    var menu = dropdown.querySelector('[data-fg-dropdown-menu]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (menu) menu.removeAttribute('hidden');
    dropdown.classList.add('is-open');
  }

  function closeDropdown(dropdown) {
    var trigger = dropdown.querySelector('[data-fg-dropdown-trigger]');
    var menu = dropdown.querySelector('[data-fg-dropdown-menu]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (menu) menu.setAttribute('hidden', '');
    dropdown.classList.remove('is-open');
  }

  function closeAllDropdowns() {
    var openOnes = document.querySelectorAll('[data-fg-dropdown].is-open');
    for (var i = 0; i < openOnes.length; i++) closeDropdown(openOnes[i]);
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;

    if (target.closest('.free-gift-block')) {
      e.stopPropagation();
    }

    var trigger = target.closest('[data-fg-dropdown-trigger]');
    if (trigger) {
      e.preventDefault();
      var dropdown = trigger.closest('[data-fg-dropdown]');
      if (!dropdown) return;
      var isOpen = dropdown.classList.contains('is-open');
      closeAllDropdowns();
      if (!isOpen) openDropdown(dropdown);
      return;
    }

    var option = target.closest('[data-fg-option]');
    if (option) {
      e.preventDefault();
      var dd = option.closest('[data-fg-dropdown]');
      if (!dd) return;
      var trig = dd.querySelector('[data-fg-dropdown-trigger]');
      var label = dd.querySelector('[data-fg-dropdown-label]');
      var variantId = option.getAttribute('data-variant-id') || '';
      var imgUrl = option.getAttribute('data-image') || '';
      var title = option.getAttribute('data-title') || '';
      if (trig) trig.setAttribute('data-selected-variant', variantId);
      if (label) label.textContent = title;
      setPreview(dd, imgUrl, title);
      closeDropdown(dd);
      return;
    }

    if (!target.closest('[data-fg-dropdown]')) {
      closeAllDropdowns();
    }

    var addSelectedBtn = target.closest('[data-free-gift-add-selected]');
    if (addSelectedBtn) {
      e.preventDefault();
      var picker = addSelectedBtn.closest('.free-gift-picker');
      var trig2 = picker && picker.querySelector('[data-fg-dropdown-trigger]');
      var variantId2 = trig2 && trig2.getAttribute('data-selected-variant');
      if (variantId2) {
        var block = addSelectedBtn.closest('[data-free-gift-block]');
        var addingLabel = (block && block.getAttribute('data-label-adding')) || 'Adding...';
        addSelectedBtn.disabled = true;
        addSelectedBtn.classList.add('is-loading');
        addSelectedBtn.textContent = addingLabel;
        addGift(variantId2);
      }
      return;
    }

    var changeBtn = target.closest('[data-free-gift-change]');
    if (changeBtn) {
      e.preventDefault();
      var block2 = changeBtn.closest('[data-free-gift-block]');
      var changingLabel = (block2 && block2.getAttribute('data-label-changing')) || 'Changing...';
      changeBtn.disabled = true;
      changeBtn.textContent = changingLabel;
      getCart().then(function (cart) {
        var gift = findGiftLine(cart);
        if (gift) {
          return removeGiftByLine(gift.lineIndex).then(refreshCartUI);
        }
      });
      return;
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var target = e.target;
    if (!target || !target.matches) return;
    if (target.matches('[data-fg-dropdown-trigger]') || target.matches('[data-fg-option]')) {
      e.preventDefault();
      target.click();
    }
  }, true);

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    var promise = origFetch.apply(this, arguments);
    if (!inflight && /\/cart\/(change|update|clear|add)/.test(urlStr)) {
      promise.then(function () {
        setTimeout(autoRemoveIfIneligible, 300);
      }).catch(function () {});
    }
    return promise;
  };

  function init() {
    autoRemoveIfIneligible();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
